export type AppVariant = 'admin' | 'campo' | 'unificado'

const APP_VARIANTS: AppVariant[] = ['admin', 'campo', 'unificado']
const RAW_VARIANT = import.meta.env.VITE_APP_VARIANT

function resolveAppVariant(value: unknown): AppVariant {
  if (typeof value === 'string' && APP_VARIANTS.includes(value as AppVariant)) {
    return value as AppVariant
  }

  if (value) {
    console.warn(
      `[AgroSchelive] VITE_APP_VARIANT inválido (${String(value)}). Usando variante unificado.`
    )
  }

  return 'unificado'
}

export const APP_VARIANT: AppVariant = resolveAppVariant(RAW_VARIANT)

export const APP_VARIANT_CONFIG = {
  admin: {
    name: 'AgroSchelive Admin',
    homeRoute: '/painel',
    allowedRoutes: ['/login', '/operadoras', '/painel', '/dashboard', '/'],
  },
  campo: {
    name: 'AgroSchelive Campo',
    homeRoute: '/campo',
    allowedRoutes: ['/login', '/operadoras', '/campo', '/'],
  },
  unificado: {
    name: 'AgroSchelive',
    homeRoute: '/painel',
    allowedRoutes: ['/login', '/operadoras', '/painel', '/campo', '/dashboard', '/'],
  },
} as const

export function isAdminApp() {
  return APP_VARIANT === 'admin'
}

export function isCampoApp() {
  return APP_VARIANT === 'campo'
}

export function getVariantHomeRoute() {
  return APP_VARIANT_CONFIG[APP_VARIANT].homeRoute
}

export function routeAllowedForVariant(pathname: string) {
  if (APP_VARIANT === 'unificado') return true
  return APP_VARIANT_CONFIG[APP_VARIANT].allowedRoutes.some(route => {
    if (route === '/') return pathname === '/'
    return pathname === route || pathname.startsWith(`${route}/`)
  })
}
